<div class="ibox detailed-view-ibox" *ngIf="parcelsService.showDetailedView && parcelsService.selectedItemData">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">{{parcelsService.selectedItemData.parcelNumber}}</div>
        <span class="close-detailed-view" (click)="parcelsService.toggleDetailedView(null)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form #form="ngForm" *ngIf="parcelsService.selectedItemData"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  autocomplete="off">
                <div class="detailed-view-navigation">
                    <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                        <div class="button-section" (click)="navPosition = 'details';"
                             [ngClass]="{'active': navPosition == 'details'}">
                            Details
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                        <div class="button-section" (click)="navPosition = 'history';"
                             [ngClass]="{'active': navPosition == 'history'}">
                            History
                        </div>
                    </div>
                </div>
                <div class="tab-content" *ngIf="navPosition == 'details'">
                    <div class="row m-b-xs"
                         *ngIf="parcelsService.buildings.length > 1"
                         (dblclick)="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && setEditModeFor(parcelsService.selectedItemData, 'building', true, form)">
                        <div class="dv-label col-md-4">
                            <label>Building</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!parcelsService.selectedItemData.formFields.building.editMode">
                            <span>{{parcelsService.selectedItemData.buildingName || '-'}}</span>
                            <i *ngIf="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && parcelsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(parcelsService.selectedItemData, 'building', true, form)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8" *ngIf="parcelsService.selectedItemData.formFields.building.editMode">
                            <select class="form-control"
                                    name="building"
                                    [disabled]="buildingSelectIsDisabled"
                                    (change)="changeBuilding($event.target.value, form)"
                                    [ngModel]="parcelsService.selectedItemData.buildingId">
                                <option value=""></option>
                                <option *ngFor="let building of parcelsService.buildingsForUpdate" [value]="building.id">
                                    {{building.name}}
                                </option>
                            </select>
                            <button type="button" (click)="applyChanges(parcelsService.selectedItemData, form, {building: form.value.building}, 'building')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(parcelsService.selectedItemData, 'building', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs" (dblclick)="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && setEditModeFor(parcelsService.selectedItemData, 'unit', true, form)">
                        <div class="dv-label col-md-4">
                            <label>Unit</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!parcelsService.selectedItemData.formFields.unit.editMode">
                            <span>{{parcelsService.selectedItemData.suiteNumber || '-'}}</span>
                            <i *ngIf="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && parcelsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(parcelsService.selectedItemData, 'unit', true, form)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8" *ngIf="parcelsService.selectedItemData.formFields.unit.editMode">
                            <search-select [ngModel]="parcelsService.selectedItemData.suiteId"
                                           name="unit"
                                           required
                                           style="height: 26px;"
                                           (ngModelChange)="changeUnit($event, form)"
                                           [data]="suiteToSearchSelect(suites)">
                            </search-select>
                            <input *ngIf="form.value.unit === 0"
                                   class="form-control"
                                   [ngModel]="parcelsService.selectedItemData.suiteNumber"
                                   name="otherSuite"
                                   placeholder="Other Unit Number"
                                   maxlength="255" required>
                            <spinner [spinnerShow]="form.value.building && !suites.length"></spinner>
                            <button type="button" (click)="applyChanges(parcelsService.selectedItemData, form, {suite: form.value.unit}, 'unit')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(parcelsService.selectedItemData, 'unit', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs"
                         (dblclick)="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && setEditModeFor(parcelsService.selectedItemData, 'resident', true, form)">
                        <div class="dv-label col-md-4">
                            <label>Resident</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!parcelsService.selectedItemData.formFields.resident.editMode">
                            <span>{{parcelsService.selectedItemData.residentFullName || '-'}}</span>
                            <i *ngIf="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && parcelsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(parcelsService.selectedItemData, 'resident', true, form)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8" *ngIf="parcelsService.selectedItemData.formFields.resident.editMode">
                            <select class="form-control"
                                    (change)="changeResident($event.target.value)"
                                    [ngModel]="parcelsService.selectedItemData.residentId"
                                    name="resident"
                                    required
                                    #residentSelect
                                    [disabled]="!residents.length">
                                <option value="" hidden></option>
                                <option *ngFor="let resident of residents" [value]="resident.id">
                                    {{resident.fullName}}
                                </option>
                            </select>
                            <input *ngIf="residentSelect.value === '0'"
                                   class="form-control"
                                   placeholder="Other Resident Name"
                                   [ngModel]="parcelsService.selectedItemData.residentFullName"
                                   name="otherResident"
                                   maxlength="255" required>
                            <spinner [spinnerShow]="form.value.unit && !residents.length"></spinner>
                            <button type="button" (click)="applyChanges(parcelsService.selectedItemData, form, {resident: form.value.resident}, 'resident')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(parcelsService.selectedItemData, 'resident', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Status</label>
                        </div>
                        <div class="col-md-8">
                            <span *ngIf="parcelsService.selectedItemData.status !== 'picked_up'"
                                  class="text-uppercase label label-{{parcelsService.selectedItemData.status}}">
                                {{parcelsService.selectedItemData.status}}
                            </span>
                            <span *ngIf="parcelsService.selectedItemData.status === 'picked_up'"
                                  class="text-uppercase label label-picked_up">
                                picked up
                            </span>
                        </div>
                    </div>

                    <div class="row m-b-xs" (dblclick)="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && setEditModeFor(parcelsService.selectedItemData, 'parcelType', true)">
                        <div class="dv-label col-md-4">
                            <label>Package Type</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!parcelsService.selectedItemData.formFields.parcelType.editMode">
                            <span>{{parcelsService.selectedItemData.parcelTypeName || '-'}}</span>
                            <i *ngIf="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && parcelsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(parcelsService.selectedItemData, 'parcelType', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8"
                             *ngIf="parcelsService.selectedItemData.formFields.parcelType.editMode">
                            <select class="form-control"
                                    name="parcelType"
                                    [ngModel]="parcelsService.selectedItemData.parcelTypeId">
                                <option value=""></option>
                                <option *ngFor="let parcelType of parcelsService.parcelTypes" [value]="parcelType.id">
                                    {{parcelType.name}}
                                </option>
                            </select>
                            <button type="button" (click)="applyChanges(parcelsService.selectedItemData, form, {parcelType: form.value.parcelType})">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(parcelsService.selectedItemData, 'parcelType', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs" (dblclick)="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && setEditModeFor(parcelsService.selectedItemData, 'numberPieces', true)">
                        <div class="dv-label col-md-4">
                            <label>Pieces</label>
                        </div>
                        <div class="dv-value col-md-8"
                             *ngIf="!parcelsService.selectedItemData.formFields.numberPieces.editMode">
                            <span>{{parcelsService.selectedItemData.numberPieces || '-'}}</span>
                            <i *ngIf="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && parcelsService.selectedItemData.isCanEdit"
                               class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(parcelsService.selectedItemData, 'numberPieces', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8"
                             *ngIf="parcelsService.selectedItemData.formFields.numberPieces.editMode">
                            <input class="form-control"
                                   name="numberPieces"
                                   [ngModel]="parcelsService.selectedItemData.numberPieces"
                                   required
                                   maxlength="255"
                                   (keyup.enter)="applyChanges(parcelsService.selectedItemData, form, {numberPieces: form.value.numberPieces})">
                            <button type="button"
                                    (click)="applyChanges(parcelsService.selectedItemData, form, {numberPieces: form.value.numberPieces})">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button"
                                    (click)="setEditModeFor(parcelsService.selectedItemData, 'numberPieces', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs" (dblclick)="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && setEditModeFor(parcelsService.selectedItemData, 'barCode', true)">
                        <div class="dv-label col-md-4">
                            <label>Barcode</label>
                        </div>
                        <div class="dv-value col-md-8"
                             *ngIf="!parcelsService.selectedItemData.formFields.barCode.editMode">
                            <span>{{parcelsService.selectedItemData.barCode || '-'}}</span>
                            <i *ngIf="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && parcelsService.selectedItemData.isCanEdit"
                               class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(parcelsService.selectedItemData, 'barCode', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8"
                             *ngIf="parcelsService.selectedItemData.formFields.barCode.editMode">
                            <input class="form-control"
                                   name="barCode"
                                   [ngModel]="parcelsService.selectedItemData.barCode"
                                   required
                                   maxlength="255"
                                   (keyup.enter)="applyChanges(parcelsService.selectedItemData, form, {barCode: form.value.barCode})">
                            <button type="button"
                                    (click)="applyChanges(parcelsService.selectedItemData, form, {barCode: form.value.barCode})">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button"
                                    (click)="setEditModeFor(parcelsService.selectedItemData, 'barCode', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs" (dblclick)="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && setEditModeFor(parcelsService.selectedItemData, 'description', true)">
                        <div class="dv-label col-md-4">
                            <label>Description</label>
                        </div>
                        <div class="dv-value col-md-8"
                             *ngIf="!parcelsService.selectedItemData.formFields.description.editMode">
                            <pre>{{parcelsService.selectedItemData.description || '-'}}</pre>
                            <i *ngIf="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && parcelsService.selectedItemData.isCanEdit"
                               class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(parcelsService.selectedItemData, 'description', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8"
                             *ngIf="parcelsService.selectedItemData.formFields.description.editMode">
                            <textarea class="form-control"
                                      name="description"
                                      [ngModel]="parcelsService.selectedItemData.description"
                                      required
                                      maxlength="255"
                                      (keyup.enter)="applyChanges(parcelsService.selectedItemData, form, {description: form.value.description})">
                            </textarea>
                            <button type="button"
                                    (click)="applyChanges(parcelsService.selectedItemData, form, {description: form.value.description})">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button"
                                    (click)="setEditModeFor(parcelsService.selectedItemData, 'description', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <hr>

                    <div class="row m-b-xs" (dblclick)="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && setEditModeFor(parcelsService.selectedItemData, 'parcelPostService', true)">
                        <div class="dv-label col-md-4">
                            <label>Courier</label>
                        </div>
                        <div class="dv-value col-md-8"
                             *ngIf="!parcelsService.selectedItemData.formFields.parcelPostService.editMode">
                            <span>{{parcelsService.selectedItemData.pickedUpByPostServiceName ||
                                    parcelsService.selectedItemData.returningByName ||
                                    parcelsService.selectedItemData.parcelPostServiceName || '-'}}</span>
                            <i *ngIf="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && parcelsService.selectedItemData.isCanEdit"
                               class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(parcelsService.selectedItemData, 'parcelPostService', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8"
                             *ngIf="parcelsService.selectedItemData.formFields.parcelPostService.editMode">
                            <select class="form-control"
                                    name="parcelPostService"
                                    [ngModel]="parcelsService.selectedItemData.parcelPostServiceId"
                                    #parcelPostServiceIdSelect
                            >
                                <option value=""></option>
                                <option *ngFor="let postService of parcelsService.postServices" [value]="postService.id">
                                    {{postService.name}}
                                </option>
                                <option value="-1">
                                    Other
                                </option>
                            </select>
                            <input *ngIf="parcelPostServiceIdSelect.value === '-1'"
                                   class="form-control"
                                   placeholder="Other Courier"
                                   [ngModel]="parcelsService.selectedItemData.parcelPostServiceId == -1 ? parcelsService.selectedItemData.parcelPostServiceName : ''"
                                   name="parcelPostServiceName"
                                   maxlength="255" required>
                            <button type="button"
                                    (click)="applyChanges(parcelsService.selectedItemData, form, {parcelPostService: form.value.parcelPostService, parcelPostServiceName: form.value.parcelPostServiceName}, 'parcelPostService')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button"
                                    (click)="setEditModeFor(parcelsService.selectedItemData, 'parcelPostService', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Date Received</label>
                        </div>
                        <div class="dv-value col-md-8">
                            {{parcelsService.selectedItemData.createdAt ? (parcelsService.selectedItemData.createdAt | date:"dd.MM.yyyy 'at' hh:mm a") : '-'}}
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Date Picked Up</label>
                        </div>
                        <div class="dv-value col-md-8">
                            {{parcelsService.selectedItemData.pickedUpAt ? (parcelsService.selectedItemData.pickedUpAt | date:"dd.MM.yyyy 'at' hh:mm a") : '-'}}
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Emailed Resident</label>
                        </div>
                        <div class="dv-value col-md-8">{{parcelsService.selectedItemData.emailNotice ? 'Yes' : 'No'}}</div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Reminder Sent At</label>
                        </div>
                        <div class="dv-value col-md-8">
                            {{parcelsService.selectedItemData.reminderSentAt ? (parcelsService.selectedItemData.reminderSentAt | mccDate:true) : '-'}}
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Signature</label>
                        </div>
                        <div class="col-md-8">
                            <span *ngIf="!parcelsService.selectedItemData.signUrl">-</span>
                            <img *ngIf="parcelsService.selectedItemData.signUrl"
                                 class="signature-image"
                                 [src]="parcelsService.selectedItemData.signUrl">
                        </div>
                    </div>
                </div>
                <div class="tab-content" *ngIf="navPosition == 'history'">
                    <div class="timeline">
                        <spinner [spinnerShow]="parcelsService.historyLoading"></spinner>
                        <ul class="timeline__list" *ngIf="!parcelsService.historyLoading">
                            <li *ngFor="let a of parcelsService.activities">
                                <section *ngIf="a.action !== 'ignore'">
                                    <header class="timeline__header">
                                    <span>
                                        <time>{{ a.loggedAt | date:'dd.MM.yyyy hh:mm a' }}</time> by {{ a.userFullName }}
                                    </span>
                                    </header>

                                    <main class="timeline__content">
                                        <div [ngSwitch]="a.action">
                                            <ng-template [ngSwitchCase]="'update'">
                                                {{ a.activityType }}
                                                <span class="timeline__active">"{{a.name}}"</span>
                                                <ul class="field-changes">
                                                    <li *ngFor="let item of a.data">
                                                        {{ item?.key }} :
                                                        <span class="timeline__active">"{{ item?.old }}"</span>
                                                        changed to
                                                        <span class="timeline__active">"{{ item?.new }}"</span>
                                                    </li>
                                                </ul>
                                            </ng-template>

                                            <ng-template [ngSwitchCase]="'create'">
                                                <p>
                                                    {{ a.activityType }}
                                                    <span class="timeline__active">"{{a.name}}"</span>
                                                    was received
                                                </p>

                                                <ul class="field-changes">
                                                    <li *ngFor="let item of a.data">
                                                        {{ item.key }} :
                                                        <span class="timeline__active">{{ item.value }}</span>
                                                    </li>
                                                </ul>
                                            </ng-template>
                                        </div>
                                    </main>
                                </section>
                            </li>
                        </ul>
                    </div>
                </div>

                <hr>

                <div class="btn-group dropup"
                     *ngIf="!(!authenticationService.userIsResident &&
                              parcelsService.selectedItemData.status === 'received' &&
                              parcelsService.selectedItemData.isCanEdit)">
                    <a data-toggle="dropdown" class="btn btn-default btn-sm dropdown-toggle">
                        Actions <span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu" style="top: -10px;">
                        <li (click)="parcelsService.printParcel(parcelsService.selectedItemData)">
                            <a>Print</a>
                        </li>
                    </ul>
                </div>

                <div class="btn-group dropup"
                     *ngIf="!authenticationService.userIsResident &&
                                parcelsService.selectedItemData.status === 'received' &&
                                parcelsService.selectedItemData.isCanEdit">
                    <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                        Actions <span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu">
                        <li (click)="parcelsService.showTransitModal(parcelsService.selectedItemData, 'pick_up')">
                            <a>Mark Pick Up</a>
                        </li>
                        <li (click)="parcelsService.editParcel(parcelsService.selectedItemData)">
                            <a>Edit</a>
                        </li>
                        <li *ngIf="parcelsService.selectedItemData.isIncomingParcel()"
                            (click)="parcelsService.showTransitModal(parcelsService.selectedItemData, 'return')">
                            <a>Return</a>
                        </li>
                        <li *ngIf="parcelsService.selectedItemData.isOutgoingParcel()"
                            (click)="parcelsService.showTransitModal(parcelsService.selectedItemData, 'cancel')">
                            <a>Cancel</a>
                        </li>
                        <li *ngIf="parcelsService.selectedItemData.isCanDelete"
                            (click)="parcelsService.remove(parcelsService.selectedItemData.id)">
                            <a>Delete</a>
                        </li>
                        <li *ngIf="receiverHasEmailOrPhone(parcelsService.selectedItemData)"
                            (click)="parcelsService.sendReminder(parcelsService.selectedItemData)">
                            <a>Send Reminder</a>
                        </li>
                        <li (click)="parcelsService.printParcel(parcelsService.selectedItemData)">
                            <a>Print</a>
                        </li>
                    </ul>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcel-detailed-view/parcel-detailed-view.component.html